<div class="Modal">
  <div mat-dialog-actions class="container-modal-header">
    <div class="icon-warning">
        <span class="material-icons me-10">
            {{data.icon}}
        </span>
        <p class="m-0 p-0">{{data.textIcon}}</p>
    </div>
    <span class="material-icons icon-close" mat-button [mat-dialog-close]="true" cdkFocusInitial>
        close
    </span>
  </div>
  
  <div class="ModalContent">
    <div class="row">
      <div class="col">
        <h1 mat-dialog-title class="TtlModal">{{data.title}}</h1>
        <p class="m-0 p-0">{{data.text}}</p>
      </div>
    </div>
  </div>

  <hr class="m-0 p-0">

  <div class="ModalContent">
    <div class="align-items-center boxBtns d-flex">
      <button class="align-items-center Btn BtnPadrao" mat-button [mat-dialog-close]="true">
        <span class="material-icons align-middle">
          {{data.btnOneIcon}}
        </span>
        {{data.textBtnOne}}
      </button>
      <button class="align-items-center Btn BtnBorder" mat-button (click)="onLaterClick()">
        {{data.textBtnTwo}}
      </button>
    </div>
  </div>

  <hr class="m-0 p-0">

  <div class="ModalContent">
    <a href={{data.routerContentLink}} routerLinkActive="router-link-active">{{data.textLink}}</a>
    <p class="text-center m-0">{{data.textExtra}}</p>
  </div>

  <div class="boxBtnContact align-items-center justify-content-center text-center">
    <app-btn-whatsapp></app-btn-whatsapp>

    <app-btn-sac></app-btn-sac>
  </div>

  <div class="box-phone">
    <span class="material-icons align-middle">
        {{data.infoBoxIcon}}
    </span>
    <div class="box-text-phone text-center">
        <span>{{data.infoBoxSpan}}</span>
        <p>
            {{data.infoBoxNumber}}
        </p>
    </div>
  </div>
</div>